import React from "react";
import { BadgeCheck, ExternalLink } from "lucide-react";
import { useContent } from "@/hooks/useContent";
import { TRUST_DEFAULTS } from "@/lib/contentDefaults";

// Trust badge: official partner of the Rouen Tourist Office (editable from admin).
export const TrustPartner = () => {
  const t = useContent("trust_badges", TRUST_DEFAULTS);
  if (!t.show_partner) return null;
  return (
    <section className="bg-nj-bg" data-testid="trust-partner">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="relative bg-white border border-nj-olive rounded-lg p-7 sm:p-9 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left shadow-[0_1px_0_rgba(28,63,58,0.04)]">
          <div className="shrink-0 h-16 w-16 rounded-full bg-nj-primary/10 flex items-center justify-center">
            <BadgeCheck className="w-8 h-8 text-nj-primary" />
          </div>
          <div className="flex-1">
            <span className="text-nj-gold text-[11px] tracking-[0.28em] uppercase font-semibold">{t.partner_eyebrow}</span>
            <h2 className="font-serif font-light text-2xl md:text-3xl text-nj-text mt-1.5">{t.partner_title}</h2>
            <p className="text-nj-text2 mt-2 leading-relaxed text-sm md:text-base">{t.partner_text}</p>
          </div>
          {t.partner_url && (
            <a
              href={t.partner_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="trust-partner-link"
              className="shrink-0 inline-flex items-center gap-2 bg-nj-primary hover:bg-nj-primaryHover text-white font-semibold px-6 py-3 rounded-sm transition-colors"
            >
              Voir notre fiche <ExternalLink className="w-4 h-4" />
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default TrustPartner;
